import { useRouter } from 'next/router';
import ar from '../../locales/ar/language';
import fr from '../../locales/fr/language';

export function useTranslation() {
    const router = useRouter();
    const { locale } = router;

    let translations;

    switch (locale) {
        case 'ar':
            translations = ar;
            break;
        case 'fr':
            translations = fr;
            break;
        default:
            translations = ar;
    }

    return translations;
}